import { render, staticRenderFns } from "./tick-square.vue?vue&type=template&id=51616dec&"
import script from "./tick-square.vue?vue&type=script&lang=js&"
export * from "./tick-square.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports